"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonTapeNodeUtils = void 0;
const jsonschema = __importStar(require("jsonschema"));
const common_1 = require("@finley-technologies/common");
// Create a utility function module
const commonTapeNodeUtils = (nodeType, artifactType, configSchema) => {
    // Type Guard for Node
    const isNode = (obj) => {
        return obj.metadata.tapeBuilderNodeType === nodeType;
    };
    // Get artifact slug
    const getArtifactSlug = (node) => {
        (0, common_1.finleyAssert)(isNode(node), `must be a ${nodeType} node`);
        return node.configuration.artifactSlug;
    };
    // Get friendly name
    const getFriendlyName = (node) => {
        return getArtifactSlug(node);
    };
    // Type Guard for Config
    const isConfig = (obj) => {
        const result = jsonschema.validate(obj, configSchema);
        return result.valid;
    };
    // Type Guard for Intermediate Record
    const isIntermediateRecord = (obj) => {
        return obj.type === artifactType;
    };
    const getTapeNode = (node) => {
        (0, common_1.finleyAssert)(isNode(node), `must be a ${nodeType} node`);
        return node;
    };
    return {
        isNode,
        getArtifactSlug,
        getFriendlyName,
        isConfig,
        isIntermediateRecord,
        getTapeNode,
    };
};
exports.commonTapeNodeUtils = commonTapeNodeUtils;
//# sourceMappingURL=commonTapeNode.js.map